<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Select from "@/components/c-select";
// import Search from "@/components/c-select-search";
import Loading from "@/components/c-loading";
import Screen from "../../../../components/screen";
import i18n from "../../../../i18n";
import { incomeExpenseItemService } from "../../../../services/settingservice/incomeexpenseitem.service";
import { servicehelpers } from "../../../../services/servicehelpers";

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Account Type Template",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    Select,
    // Search,
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Account Type template",
      breadCrumb: {},

      type: {},
      data: {},
      account: {},
      account_income: {},
      account_expense: {},
      valueName: "",
      valueNameEn: "",
      valueItemTypeId: 0,
      valueAccountId: 0
    };
  },
  mounted() {

    this.loadingNatureData();

    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } else {
      this.loadingData(0);
    }
  },

  methods: {

    loadingData: function(id) {
      this.fetchingStats = false;
      console.log(id);
      incomeExpenseItemService.getOne(id)
        .then(response => {

          this.breadCrumb = {
            // text: response.data.name,
            text: "កែប្រែមុខចំណូលឬចំណាយ", //i18n.t('income.edit'),
            active: true,
          };
          
          this.fetchingStats = true;

          if(id != 0) {
            this.data = response.data;
            this.valueName = this.data.name;
            this.valueNameEn = this.data.name_en;
            this.valueItemTypeId = this.data.item_type_id;
            this.valueAccountId = 0;
          }

          this.loadingSettings(response.setting);
        });
    },

    loadingNatureData: function() {

      servicehelpers.getIncomeExpenseItemType().then(response => {
        this.type = response;
      });
    },

    loadingSettings: function(setting) {

      // console.log(JSON.stringify(setting));

      // this.account_income = {data: setting.accounts.filter((item) => (item.account_type_id == 4 || item.account_type_id == 6 || item.account_type_id == 8 || item.account_type_id == 10 || item.account_type_id == 11))};
      // this.account_expense = {data: setting.accounts.filter((item) => item.account_type_id == 13)};

      // this.account_income = {data: setting.accounts.filter((item) => (item.account_type_id == 4 || item.account_type_id == 6 || item.account_type_id == 8 || item.account_type_id == 10 || item.account_type_id == 11))};
      // this.account_expense = {data: setting.accounts.filter((item) => (item.account_type_id == 4 || item.account_type_id == 6 || item.account_type_id == 8 || item.account_type_id == 13))};

      this.account_income = {data: setting.accounts};
      this.account_expense = {data: setting.accounts};

      this.account = (this.valueItemTypeId == 1) ? this.account_income : this.account_expense;
    },

    changedType: function(event) {
      // console.log(event);
      this.account = (event == 1) ? this.account_income : this.account_expense;
    },


    submitSave: function() {
      
      this.tryingToSubmit = true;

      let type = {
        name: this.valueName,
        name_en: this.valueNameEn,
        item_type_id: this.valueItemTypeId,
        chart_account_id: 0
      };
      
      // console.log(JSON.stringify(type));
      
      if(this.isAdd) {
        incomeExpenseItemService.insert(type).then(response => {
          if(response.status == 200) {
            
            this.tryingToSubmit = false;

            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.success.yes'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (!result.value) {

                this.$router.push(this.$route.query.redirectFrom || {
                  name: "setting-incomeexpense-item"
                });
              } 
            });

          }
        });
      } else {
        incomeExpenseItemService.update(this.$route.params.id, type).then(response => {
          if(response.status == 200) {
            
            this.tryingToSubmit = false;

            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.success.yes'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (!result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "setting-incomeexpense-item"
                });
              } 
            });

          }
        });
      }

    }

  }
};
</script>

<template>
  <Layout>
    <!-- <PageHeader :items="['']" :title="$t('setting.configuration.loan-template.text')" /> -->
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('setting.income-expense-item.text'),
        href: '/setting/incomeexpense/item',
      }, {
        text: $t('setting.income-expense-item.new'),
        active: true
      }]" :title="this.isAdd ? $t('setting.income-expense-item.new') : $t('setting.income-expense-item.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('setting.income-expense-item.text'),
        href: '/setting/pl/account/type',
      }, this.breadCrumb]" :title="this.isAdd ? $t('setting.income-expense-item.new') : $t('setting.income-expense-item.edit')" />
    </div>
    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              <div class="row">
                
                <div class="col-md-3">
                  <Input 
                    :type="'text'"
                    :id="'name'"
                    v-model="valueName"
                    :require="true"
                    :label="'setting.income-expense-item.name'"  />
                </div>
                <div class="col-md-3">
                  <Input 
                    :type="'text'"
                    :id="'name'"
                    v-model="valueNameEn"
                    :require="true"
                    :label="'setting.income-expense-item.name-en'"  />
                </div>
                <div class="col-md-3">
                   <Select 
                    :text="'name'"
                    :id="'item_type'"
                    v-model="valueItemTypeId"
                    @change="changedType"
                    :list="this.type"
                    :require="true"
                    :label="'setting.income-expense-item.type'"  />
                </div>

              </div>


              <div class="row">
                <div class="col-lg-12">

                  <div inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </div>
    
                </div>
              </div>
          
          </div>
        </div>
      </div>
    </b-form> 
  </Layout>
</template>